import React, { useContext } from 'react'
import { PostPurchaseContext } from '../context/PostPurchaseContext';
import { formatPrice } from '../utilities';
import AddToCart from './AddToCart'

function ExtendWarranty() {
    function formatWarrantyTitle(title) {
        return `${title.split(" - ")[1].toLowerCase().replace('year', 'yr').split(' ').join('')}.`
    }
    const state = useContext(PostPurchaseContext);
    return (
        <div className='flex flex-col justify-center w-full gap-y-2.5 pt-8'>
            <h3 className="text-white font-bold text-5xl text-center normal-case">Extend Your Warranty?</h3>
            <small className="text-center leading-none block">Extended warranty must be purchased within 30 days of original date of purchase.</small>
            <ul className="flex justify-center gap-8 items-center py-8">

                {state.warrantyProducts && state.warrantyProducts.map(extendedWarranty => {
                    return (<li key={extendedWarranty.id} className="flex flex-col items-center gap-1">
                        <div className="uppercase mx-auto">Extra</div>
                        <div className="w-[60px] h-[60px] text-5xl flex items-center justify-center rounded-full border-2 border-white">{formatWarrantyTitle(extendedWarranty.title)}</div>
                        <span>{formatPrice(extendedWarranty.price)}</span>
                        { extendedWarranty.available ? <AddToCart name="extendedWarranty" productId={extendedWarranty.variants[0].id} /> : " "}
                    </li>
                    )
                })}
            </ul>
        </div>
    )
}

export default ExtendWarranty